app.service('basketVoucher', function (modal, loading, broker, cookie,
	message, front, log, keycloak,
	loginModal, pageConfig, simpleToastr, console) {
	let $voucherInput, $checkboxes;
	let $self, config;
	let $checkboxesVoucherSection, $checkboxesVoucherSectionError;
	let $manualVoucherToggle, $manualVoucherContent, $manualVoucherSection, $manualVoucherSectionError;
	let successAdded = false;
	let successAddedMessage = false;

	function logEvent(params) {
		const basket = pageConfig.getData('basket');
		const plus = [];
		$(basket.items).each(function () {
			plus.push(this.plu);
		});
		log.event(Object.assign({}, {
			f03: cookie.get(front.euro ? 'euroCart' : 'oleoleCart'),
			f05: plus.join(";"),
			f06: config.summaryPrice,
			f07: config.voucherCode?.join(';'),						// lista aktywnych kodów
			f08: config.basketVouchers?.map(voucher => voucher.code).join(';')		// lista wyświetlanych kodów
		}, params));
	}
	function logVouchersOnSend() {
		// Logowanie wszystkich dotępnych kodów i ich stanu (zaznaczony/niezaznaczony) podczas próby przejścia dalej na koszyku
		const vouchers = config.basketVouchers || [];
		logEvent({
			id: 'cart_vouchers',
			f04: vouchers.map(voucher => (['MANUAL'].includes(voucher.type) && voucher.selected ? 1 : 0)).reduce((a, b) => a + b, 0), //liczba zaznaczonych kodów produktowych (MANUAL)
			f05: vouchers.map(voucher => (['MANUAL'].includes(voucher.type) && !voucher.selected ? 1 : 0)).reduce((a, b) => a + b, 0), //liczba niezaznaczonych kodów produktowych (MANUAL)
			f06: vouchers.map(voucher => (['MULTIDISCOUNT'].includes(voucher.type) && voucher.selected ? 1 : 0)).reduce((a, b) => a + b, 0), //liczba zaznaczonych kodów koszykowych (MULTIDISCOUNT)
			f07: vouchers.map(voucher => (['MULTIDISCOUNT'].includes(voucher.type) && !voucher.selected ? 1 : 0)).reduce((a, b) => a + b, 0), //liczba niezaznaczonych kodów koszykowych (MULTIDISCOUNT)
			f08: vouchers.map(voucher => (['CASHBACK', 'CUSTOMER'].includes(voucher.type) && voucher.selected ? 1 : 0)).reduce((a, b) => a + b, 0), //liczba zaznaczonych kodów CRM (CUSTOMER + CASHBACK)
			f09: vouchers.map(voucher => (['CASHBACK', 'CUSTOMER'].includes(voucher.type) && !voucher.selected ? 1 : 0)).reduce((a, b) => a + b, 0), //liczba niezaznaczonych kodów CRM (CUSTOMER + CASHBACK)
			f10: config.voucherCode?.join(','), // lista zaznaczonych kodów oddzielonych przecinkiem
		});
	}

	function updateCheckboxState(voucherCode, isChecked) {
		const $checkbox = $checkboxes.filter(`[value="${voucherCode}"]`);
		if ($checkbox.length) {
			$checkbox.prop('checked', isChecked);
			$checkbox.attr('aria-checked', isChecked ? 'true' : 'false');
		}
	}

	function voucherCheckboxChange(voucherCode, isChecked) {

		if (isChecked) {
			submitVoucher(voucherCode, { source: 'checkbox' });
		} else {
			removeVoucher(voucherCode, {
				onError: () => updateCheckboxState(voucherCode, true)
			});
		}
	}

	function activateVoucherByCode(voucherCode) {
		submitVoucher(voucherCode);
	}

	function showConfirmationDialog(productsVouchersErrorMessage, { onConfirm, onCancel } = {}) {
		modal.generate({
			id: 'modal-voucher-conflict',
			header: getProductsVouchersErrorMessage(productsVouchersErrorMessage.header),
			content: productsVouchersErrorMessage.content,
			buttons: [
				{
					text: 'Anuluj',
					cssClass: 'btn-cancel',
					click: function () {
						modal.close();
						onCancel && onCancel();
					}
				},
				{
					text: 'Tak, aktywuj',
					cssClass: 'btn-confirm',
					click: function () {
						modal.close();
						onConfirm && onConfirm();
					}
				}
			]
		});
	}

	function submitVoucher(voucherCode, { overwrite = false, source = 'manual' } = { source: 'manual' }) {
		loading.start();
		if (overwrite) {
			logEvent({ id: 'overwrite-voucher', f04: voucherCode });
		} else {
			logEvent({ id: 'apply-voucher', f04: voucherCode });
		}

		const md5Sum = pageConfig.getData('basket').cartHashMd5Sum;
		const data = overwrite
			? { voucherCode, overwrite: true, md5Sum }
			: { voucherCode, md5Sum };

		$.ajax({
			type: 'POST',
			url: '/applyVoucherToCart.ltr',
			dataType: 'json',
			data,
			success: (res) => {
				loading.stop();
				successVoucherApply(res, data, source);
			},
			error: () => {
				loading.stop()
				updateCheckboxState(voucherCode, false);
				modal.alert('Błąd aktywacji kodu rabatowego');
			}
		});
	}

	function removeVoucher(voucherCode, { onError } = {}) {
		loading.start();
		logEvent({ id: 'remove-voucher', f04: voucherCode });

		$.ajax({
			type: 'POST',
			url: '/removeVoucherFromCart.ltr',
			data: { voucherCode },
			success: function () {
				broker.trigger('REFRESH_BASKET_VIEW', { type: 'remove-voucher', voucher: voucherCode });
			},
			error: function () {
				loading.stop();
				onError && onError();
				modal.alert('Błąd usuwania kodu rabatowego');
			}
		});
	}

	function successVoucherApply(res, data, source) {
		cleanValidationError();

		if (res.cartNeedsRefresh) {
			loading.redirect('/cart.bhtml');
			return;
		}

		if (pageConfig.getData('operator').isLogged && !pageConfig.getData('operator').frontUserLogged && res.loginNeeded) {
			logEvent({ id: 'operator-login-needed', f04: data.voucherCode });
			loading.redirect('/cart-front-operator-customer-login.bhtml');
			return;
		}

		if (res.loginNeeded) {

			if (config.keycloakEnabled) {
				keycloak.showModal({
					type: 'k1-voucher',
					voucherCode: data.voucherCode
				});
				return;
			}

			logEvent({ id: 'login-needed-voucher', f04: data.voucherCode });
			if (config.voucherLoginModal) {
				openLoginModal(data.voucherCode);
			} else {
				loading.redirect({
					href: res.loginUrl,
					soft: true
				});
			}
			return;
		}

		if (res.productsVouchersErrorMessage != null) {
			updateCheckboxState(data.voucherCode, false);
			logEvent({ id: 'dialog-voucher', f04: data.voucherCode });
			showConfirmationDialog(res.productsVouchersErrorMessage, {
				onConfirm: () => {
					updateCheckboxState(data.voucherCode, true);
					submitVoucher(data.voucherCode, { overwrite: true, source });
				},
				onCancel: () => {
					logEvent({ id: 'cancel-voucher', f04: data.voucherCode });
				}
			});
			return;
		}

		if (res.errorMessage && res.errorMessage.length > 0) {
			logEvent({ id: 'error-voucher', f04: data.voucherCode });
			applyValidationError(source, res.errorMessage)
			return;
		}

		successAdded = true;
		logEvent({ id: 'added-voucher', f04: data.voucherCode });
		successAddedMessage = res.message ? res.message : false;
		broker.trigger('REFRESH_BASKET_VIEW', { type: 'add-voucher', voucher: data.voucherCode });
	}

	function getProductsVouchersErrorMessage(errorType) {
		switch (errorType) {
			case 'PRODUCT_VOUCHER_WITH_BASKET_VOUCHER_ERROR':
				return 'Ta promocja nie łączy się z aktywnym kodem';
			case 'PRODUCT_VOUCHER_WITH_MULTIPLE_BASKET_VOUCHERS_ERROR':
				return 'Ta promocja nie łączy się z aktywnymi kodami';
			case 'BASKET_VOUCHER_WITH_PRODUCT_VOUCHER_ERROR':
				return 'Ten kod nie łączy się z aktywną promocją';
			case 'BASKET_VOUCHER_WITH_BASKET_VOUCHER_ERROR':
				return 'Promocje nie łączą się ze sobą'
			case 'PRODUCT_VOUCHER_WITH_PRODUCT_VOUCHER_ERROR':
				return 'Ten kod nie łączy się z aktywnym kodem'
			default:
				return '';
		}
	}

	function voucherCodeHasChanged() {
		const voucherCode = $voucherInput.val();
		return voucherCode.length > 0;
	}

	function applyVoucherAction() {
		const voucherCode = $voucherInput.val().trim();
		if (voucherCode.length > 0 && !/^[0-9a-zA-Z._-]+$/.test(voucherCode)) {
			showInvalidVoucherMessage();
			return false;
		}
		if (voucherCode && voucherCode.length) {
			submitVoucher(voucherCode);
		}
	}

	function getElementBasedOnSource(source) {
		switch (source) {
			case 'manual':
				return { $wrapper: $manualVoucherSection, $error: $manualVoucherSectionError }
			case 'checkbox':
				return { $wrapper: $checkboxesVoucherSection, $error: $checkboxesVoucherSectionError }
		}

		console.log('Brak elementu dla przekazanego source: ', { source });

		return {}
	}

	function applyValidationError(source, errorMessage) {
		const { $wrapper, $error } = getElementBasedOnSource(source);
		if (!$wrapper) {
			return;
		}

		$wrapper
			.addClass('voucher-error')
			.find('.validate-target')
			.addClass('validate-error');

		if (errorMessage && $error) {
			$error.html(errorMessage);
		}
	}

	function cleanValidationError() {
		$checkboxesVoucherSectionError.empty();
		$manualVoucherSectionError.empty();

		$manualVoucherSection
			.add($checkboxesVoucherSection)
			.removeClass('voucher-error')
			.find('.validate-target')
			.removeClass('validate-error');
	}

	function showInvalidVoucherMessage() {
		modal.alert('Nieprawidłowy format kodu rabatowego!');
	}

	function removeVoucherAction(voucherCode) {
		successAdded = false;
		if (voucherCode && voucherCode.length) {
			removeVoucher(voucherCode);
		}
	}

	function handleInputKeypress(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			applyVoucherAction();
		}
	}

	function handleInputKeyup(e) {
		const value = $voucherInput.val().trim();
		const hasValue = !!value;
		$manualVoucherContent.toggleClass('has-value', hasValue);
		cleanValidationError();
	}
	function cleanVoucherAction(callback) {
		$voucherInput.val('');
		cleanValidationError();
		if (callback) {
			callback();
		}
	}

	function check(callback) {
		if ($self.length && voucherCodeHasChanged()) {
			message.get('cart.bhtml - niezastosowano kodu rabatowego').then(function (m) {
				modal.generate({
					content: m,
					id: 'apply-voucher-modal',
					modifier: 'remodal-full-width',
					buttons: [{
						text: 'Przejdź dalej bez kodu',
						cssClass: 'btn-third',
						click: function () {
							modal.close(false);
							cleanVoucherAction(callback);
						}
					}, {
						text: 'Dodaj kod',
						cssClass: 'btn-second',
						click: function () {
							modal.close(false);
							applyVoucherAction();
						}
					}]
				});
			});
			return true;
		}
		return false;
	}

	function openLoginModal(voucherCode) {
		loginModal.load({
			type: 'login-voucher',
			voucherCode: voucherCode,
			callbackSuccess: function () {
				applyVoucherAction();
			}
		});
	}

	function setEvents() {
		$voucherInput.keyfilter(/[\da-zA-Z\.\-\_]/);
		$self
			.on('click', '.js-accept-voucher', function () {
				applyVoucherAction();
			})
			.on('click', '.js-remove-voucher', function () {
				removeVoucherAction($(this).data('voucher'));
			})
			.on('click', '.js-voucher-login', function () {				// element jest w komunikacie Euro
				openLoginModal();
			})
			.on('click', '.js-toggle-manual-voucher', function () {
				const isExpanded = $manualVoucherToggle.attr('aria-expanded') === 'true';
				if (isExpanded) {
					$manualVoucherContent.removeClass('expanded');
					$manualVoucherToggle.attr('aria-expanded', 'false');
				} else {
					$manualVoucherContent.addClass('expanded');
					$manualVoucherToggle.attr('aria-expanded', 'true');
				}
			})
			.on('change', '.js-voucher-checkbox', function () {
				const $checkbox = $(this);
				const voucherCode = $checkbox.val();
				const isChecked = $checkbox.prop('checked');
				voucherCheckboxChange(voucherCode, isChecked);
			});

		$voucherInput.on('input', handleInputKeyup).on('keypress', handleInputKeypress);

		if (successAdded && !$self.hasClass('voucher-error')) {
			successAdded = false;
			if (successAddedMessage && successAddedMessage.length) {
				simpleToastr.generate(successAddedMessage, { closeOthers: true });
				successAddedMessage = false;
			}
		}
	}

	function setElements() {
		$self = $('#voucher-box');
		$voucherInput = $('#voucher-input', $self);

		$checkboxesVoucherSection = $('.available-vouchers-section', $self);
		$checkboxesVoucherSectionError = $('.voucher-messages', $checkboxesVoucherSection);

		$manualVoucherSection = $('.manual-voucher-section', $self);
		$manualVoucherToggle = $('.js-toggle-manual-voucher', $self);
		$manualVoucherContent = $('#manual-voucher-content', $self);
		$manualVoucherSectionError = $('.voucher-messages', $manualVoucherSection);

		$checkboxes = $('input.js-voucher-checkbox', $self);
		config = pageConfig.getData('order');

		if (config.voucherCodesErrorsOnPath != '') {
			logEvent({ id: 'voucher-changed-before-order-finalization', f04: config.voucherCodesErrorsOnPath });
		}
	}

	function init() {
		setElements();
		setEvents();
	}
	function checkAfterLogin(voucherCode) {
		if (voucherCode && voucherCode.length) {
			if (config.voucherCode.filter(v => v.toLowerCase() == voucherCode.toLowerCase()).length) {
				simpleToastr.generate('Kod rabatowy został aktywowany', { closeOthers: true });
			} else {
				$voucherInput.val(voucherCode);
				$manualVoucherContent.addClass('expanded');
				activateVoucherByCode(voucherCode);
			}
		}
	}

	return { init, check, activateVoucherByCode, logVouchersOnSend, checkAfterLogin };
});
